import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { arrayRemove, arrayUnion, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { getStorage, ref } from 'firebase/storage';

// Two Firebase projects. Billing ledger B1.1.
// Live: yedding.com. Staging: PR previews only, fake data, Stripe sandbox.
// Only the PR workflow sets REACT_APP_FIREBASE_ENV=staging. No value = live,
// so the production build cannot point at staging by accident.
const FIREBASE_CONFIGS = {
  live: {
    apiKey: 'AIzaSyAnjMGKmKaCOHP9VDPHqxULD2gOZCrRU6s',
    authDomain: 'yedding-c8cf7.firebaseapp.com',
    projectId: 'yedding-c8cf7',
    storageBucket: 'yedding-c8cf7.appspot.com',
    messagingSenderId: '128078792205',
    appId: '1:128078792205:web:951547c9378dc83e763744',
    measurementId: 'G-BF7P0BTSHH'
  },
  staging: {
    apiKey: 'AIzaSyCbWto1dvCCV4rsDXwpbAnBf335LNE2O3U',
    authDomain: 'yedding-staging.firebaseapp.com',
    projectId: 'yedding-staging',
    storageBucket: 'yedding-staging.firebasestorage.app',
    messagingSenderId: '265616776010',
    appId: '1:265616776010:web:3a5c8bcea6208f861c3fb3'
  }
};

const IS_STAGING = process.env.REACT_APP_FIREBASE_ENV === 'staging';
const firebaseConfig = IS_STAGING ? FIREBASE_CONFIGS.staging : FIREBASE_CONFIGS.live;
const PROJECT_ID = firebaseConfig.projectId;

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// `yarn start` only. A production build on localhost (scripts/e2e-session.sh)
// calls the real staging functions, like a preview does.
if (window.location.hostname === 'localhost' && process.env.NODE_ENV === 'development') {
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

// import { getDocs } from 'firebase/firestore';

// const venuesRef = collection(db, 'venues');
// let search = query(venuesRef, where('verified', '==', true));
// search = query(search, where('location.lat', '>=', 10));
// search = query(search, where('location.lat', '<=', 50));

// getDocs(search).then((querySnapshot) => {
//   querySnapshot.forEach((doc) => {
//     console.log(doc.id, ' => ', doc.data());
//   });
// });

export { arrayRemove, arrayUnion, auth, db, functions, IS_STAGING, PROJECT_ID, storage, ref as storageReference };
